import React from 'react';
import { WobbleCard } from "../components/ui/wobble-card.tsx";
import projects from "../assets/images/projects.jpeg"
import profile from "../assets/images/profile.jpeg"

const Features = () => {
  return (
    <section className="bg-black text-white py-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
        <h2 className="text-5xl font-bold mb-12 text-center ">Our Features</h2>
        <div className="p-4 grid grid-cols-1 lg:grid-cols-3 gap-4 max-w-7xl mx-auto w-full">
      <WobbleCard
        containerClassName="col-span-1 lg:col-span-2 h-full bg-pink-800 min-h-[500px] lg:min-h-[300px]"
        className=""
      >
        <div className="max-w-xs">
          <h2 className="text-left text-balance text-base md:text-xl lg:text-3xl font-semibold tracking-[-0.015em] text-white">
          Unlock Your Professional Potential
          </h2>
          <p className="mt-4 text-left  text-base/6 text-neutral-200">
          With over 100 monthly active users, Buildr is an emerging way for developers to present their work effectively.

          </p>
        </div>
        <img
          src={profile}
          width={300}  // Adjusted width
          height={300} // Adjusted height
          alt="linear demo image"
          className="scale-90 absolute -right-40 lg:-right-[1%] -bottom-2 object-contain rounded-xl"  // Adjusted scale and positioning
        />

      </WobbleCard>
      <WobbleCard containerClassName="col-span-1 min-h-[300px]">
        <h2 className="max-w-80  text-left text-balance text-base md:text-xl lg:text-3xl font-semibold tracking-[-0.015em] text-white">
        No Limits, Just Showcase
        </h2>
        <p className="mt-4 max-w-[26rem] text-left  text-base/6 text-neutral-200">
        Buildr supports you in showcasing your work with no restrictions, providing a seamless experience.
        </p>
      </WobbleCard>
      <WobbleCard containerClassName="col-span-1 lg:col-span-3 bg-blue-900 min-h-[500px] lg:min-h-[600px] xl:min-h-[300px]">
        <div className="max-w-sm">
          <h2 className="max-w-sm md:max-w-lg  text-left text-balance text-base md:text-xl lg:text-3xl font-semibold tracking-[-0.015em] text-white">
            Sign Up for Buildr Today!
          </h2>
          <p className="mt-4 max-w-[26rem] text-left  text-base/6 text-neutral-200">
          Join a thriving community of developers on the premier platform for creating and sharing portfolios.          </p>
        </div>
        <img
          src={projects}
          width={500}
          height={500}
          alt="linear demo image"
          className="scale-125 absolute absolute -right-20 lg:-right-[1%] -bottom-2 object-contain rounded-2xl"
        />
      </WobbleCard>
    </div>
      </div>
    </section>
  );
};

export default Features;
